import { RegisterInput as RegisterInputG } from './generated/graphql';

export type ResultSuccess = {
    __typename: 'ResultSuccess';
    success: boolean;
};

export type RegisterInput = RequireOnlyOne<RegisterInputG, 'town' | 'postcode'>;

type RequireOnlyOne<T, Keys extends keyof T = keyof T> = Pick<
    T,
    Exclude<keyof T, Keys>
> &
    {
        [K in Keys]-?: Required<Pick<T, K>> &
            Partial<Record<Exclude<Keys, K>, undefined>>;
    }[Keys];

export enum ErrorCodesEnum {
    DEFAULT = -666,
    LOGIN_INVALID = -200,
    LOGIN_USER_DELETED = -201,
    LOGIN_USER_BLOCKED = -202,
    USERNAME_MIN_CHARS = -20,
    USERNAME_MAX_CHARS = -21,
    USERNAME_EXISTS = -22,
    PASSWORD_MIN_CHARS = -23,
    AGE = -24,
    AGE_LENGTH = -25,
    PASSWORD_MAX_CHARS = -26,
    TIMEZONE = -27,
    LANGUAGE_EXISTS = -28,
    EMAIL_INVALID = -10,
    EMAIL_EXISTS = -11,
    EMAIL_ALREADY_SET = -12,
    MOBILENUMBER_INVALID = -15,
    MOBILENUMBER_EXISTS = -16,
    MOBILENUMBER_ALREADY_SET = -17,
    COUPON_INVALID = -30,
    COUPON_REDEEMED = -31,
    COINS_MISSING = -100,
    COINS_FAILURE = -101,
    STATUS_FAILURE = -102,
    POSTCODE_INVALID = -42,
    POSTCODE_NOT_EXISTS = -43,
    TOWN_INVALID = -44,
    TOWN_NOT_EXISTS = -45,
    COUNTRY_INVALID = -50,
    COUNTRY_NOT_EXISTS = -51,
    FLIRTTEXT_MAX_CHARS = -52,
    USERNAME_MISSING = -53,
    PROVIDER_INVALID = -7000,
    TRANSACTION_CREATE_FAILED = -7001,
    TRANSACTION_CALLBACK_FAILED = -7002,
    TRANSACTION_CALLBACK_WRONG_AMOUNT = -7003,
    TRANSACTION_CALLBACK_INVALID_DATA = -7004,
    TRANSACTION_CALLBACK_CORRUPTED_DATA = -7005,
    TRANSACTION_LIMIT_REACHED = -7006,
    TRANSACTION_OFFER_INVALID = -7007,
    TRANSACTION_OFFER_INACTIVE = -7008,
    TRANSACTION_PROJECT_MISMATCH = -7009,
    TRANSACTION_CALLBACK_CAPTURE_FAILED = -7010,
    TRANSACTION_OFFER_PREMIUM_ACTIVE = -7011,
    CONVERSATION_NOT_FOUND = -301,
    PROFILE_NOT_FOUND = -303,
    MAIN_IMAGE_NOT_FOUND = -302,
    MATCH_NOT_ACTIVE = -400,
    MATCH_LIMIT_BUY_MORE = -401,
    MATCH_LIMIT = -402,
    MATCH_BUY_MORE = -403,
    MATCH_NOT_FOUND = -404,
    INPUT_INCORRECT = -1,
}
